import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=5b6e0b44&scoped=true"
import script from "./message-list.vue?vue&type=script&lang=js"
export * from "./message-list.vue?vue&type=script&lang=js"
import style0 from "./message-list.vue?vue&type=style&index=0&id=5b6e0b44&scoped=true&language=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e0b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6e0b44')) {
      api.createRecord('5b6e0b44', component.options)
    } else {
      api.reload('5b6e0b44', component.options)
    }
    module.hot.accept("./message-list.vue?vue&type=template&id=5b6e0b44&scoped=true", function () {
      api.rerender('5b6e0b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/agent-messages/message-list.vue"
export default component.exports